// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"5d27db81","513":"27c5218f","703":"a878a678","787":"6491f8da"}[chunkId] + ".chunk.js";
};